import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CodeInputModule } from 'angular-code-input';

import { SharedModule } from '../shared';
import { AccountRoutingModule } from './account-routing.module';
import { AccountComponent } from './account.component';
import { SecurityCodeComponent } from './components';
import { PersonalInformationComponent } from './pages';

@NgModule({
    declarations: [
        AccountComponent,
        PersonalInformationComponent,
        SecurityCodeComponent
    ],
    imports: [CommonModule, AccountRoutingModule, SharedModule, CodeInputModule]
})
export class AccountModule {}
